<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    珠光站<br>
站点介绍<br>
珠光站位于龙珠大道路中沿龙珠大道下。北侧为珠光村、龙都花园和龙联花园的住宅区，南侧为龙辉花园的住宅区和珠光小学。珠光站装修以米白色及绿色天花为主色调，采用LED棚顶圆圈为重点设计特色，整个空间协调统一。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:16	23:50	7号线	3分35秒	5分55秒<br>
太安	06:21	23:06	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:21	23:50	7号线	4分钟	5分55秒<br>
太安	06:26	23:06	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:21	00:50	7号线	4分钟	5分55秒<br>
太安	06:26	00:06	7号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
B出入口:<br>
龙珠大道南侧、龙辉花园、珠光小学、汇文苑<br><br>
C出入口:<br>
龙珠大道北侧、龙联花园、珠光花半里、珠光村、龙祥苑<br><br>
D出入口:<br>
龙珠大道北侧、龙都花园、润城花园、宝珠花园<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 龙辉花园<br>
19路,104路,201路,235路,326路,M369路,N8路,高峰专线49路<br><br>
C出入口:<br>
公交站名： 龙辉花园<br>
19路,104路,201路,235路,326路,M369路,N8路,高峰专线49路<br><br>
D出入口:<br>
公交站名： 龙辉花园<br>
334路,M203路,M474路,高峰专线26路,高峰专线62路 高峰专线166路 72 路 M234路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>